import tavern from "../../Assets/TavernLookDev/Tavern4.jpg";
import antiqueshop from "../../Assets/AntiqueShopLookDev/shop7.jpg";
import blender from "../../Assets/Blender/blender2.png";

const DSWorkCardData = [
    {
        imgsrc: blender,
        title: "3D modelling in Blender Course",
        description: "An online modelling course covering modelling, UV unwrapping, and texturing in Blender.",
        skills: "Skills Used: Blender",
        view: "/Page_BlenderCourse"
    },
    {
        imgsrc: antiqueshop,
        title: "Final Year Look Development Project",
        description: "3D Modelling project based around designing and modelling an antique shop and two characters.",
        skills: "Skills Used: Maya, Substance Painter, Zbrush",
        view: "/Page_AntiqueShopLookDev"
    },
    {
        imgsrc: tavern,
        title: "Tavern Look Development Project",
        description: "A second year project involving modelling, texturing and lighting a medieval style tavern and all its assets.",
        skills: "Skills Used: Maya",
        view: "/Page_TavernLookDev"
    },
]
export default DSWorkCardData;